export default "__VITE_ASSET__D24vjuER__"